<!-- Query Parameter Form - Slide-in Panel -->
@if (IsOpen && ShowOverlay) {
  <div class="param-form-overlay"
    @fadeIn
    (click)="Cancel()">
  </div>
}

@if (IsOpen) {
  <div class="param-form-panel"
    @slideIn
    [style.width.px]="PanelWidth">
    <!-- Header -->
    <div class="panel-header">
      <div class="header-content">
        <i class="fa-solid fa-sliders header-icon"></i>
        <div class="header-text">
          <h3 class="header-title">Query Parameters</h3>
          @if (QueryInfo) {
            <span class="header-subtitle">{{ QueryInfo.Name }}</span>
          }
        </div>
      </div>
      <button class="close-btn" (click)="Cancel()" title="Close">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
    <!-- Form Content -->
    <div class="panel-content">
      <!-- No parameters message -->
      @if (Fields.length === 0) {
        <div class="no-params">
          <i class="fa-solid fa-check-circle no-params-icon"></i>
          <p>This query has no parameters</p>
          <button class="btn btn-primary" (click)="Submit()">
            Run Query
          </button>
        </div>
      }
      <!-- Parameter fields -->
      @if (Fields.length > 0) {
        <div class="param-fields">
          @for (field of Fields; track TrackByField($index, field)) {
            <div class="param-field"
              [class.has-error]="field.error && field.touched"
              [class.required]="field.info.IsRequired">
              <!-- Label -->
              <label class="field-label" [for]="'param-' + field.info.Name">
                {{ field.info.Name }}
                @if (field.info.IsRequired) {
                  <span class="required-indicator">*</span>
                }
                <span class="field-type">({{ field.info.Type }})</span>
              </label>
              <!-- Description -->
              @if (field.info.Description) {
                <p class="field-description">
                  {{ field.info.Description }}
                </p>
              }
              <!-- String input -->
              @if (field.info.Type === 'string') {
                <input type="text"
                  class="form-input"
                  [id]="'param-' + field.info.Name"
                  [value]="GetStringValue(field.value)"
                  [placeholder]="GetPlaceholder(field.info)"
                  (input)="OnInputChange(field, $event)">
              }
              <!-- Number input -->
              @if (field.info.Type === 'number') {
                <input type="number"
                  class="form-input"
                  [id]="'param-' + field.info.Name"
                  [value]="GetNumberValue(field.value)"
                  [placeholder]="GetPlaceholder(field.info)"
                  (input)="OnNumberInputChange(field, $event)">
              }
              <!-- Date input -->
              @if (field.info.Type === 'date') {
                <input type="date"
                  class="form-input"
                  [id]="'param-' + field.info.Name"
                  [value]="GetDateValue(field.value)"
                  (input)="OnDateInputChange(field, $event)">
              }
              <!-- Boolean input -->
              @if (field.info.Type === 'boolean') {
                <div class="checkbox-wrapper">
                  <input type="checkbox"
                    [id]="'param-' + field.info.Name"
                    [checked]="GetBooleanValue(field.value)"
                    (change)="OnCheckboxChange(field, $event)">
                  <label [for]="'param-' + field.info.Name" class="checkbox-label">
                    {{ GetBooleanValue(field.value) ? 'Yes' : 'No' }}
                  </label>
                </div>
              }
              <!-- Array input (comma-separated) -->
              @if (field.info.Type === 'array') {
                <input type="text"
                  class="form-input"
                  [id]="'param-' + field.info.Name"
                  [value]="GetArrayDisplayValue(field.value)"
                  [placeholder]="GetPlaceholder(field.info) || 'Enter values separated by commas'"
                  (input)="OnArrayInputChange(field, $event)">
                <span class="field-hint">Enter multiple values separated by commas</span>
              }
              <!-- Error message -->
              @if (field.error && field.touched) {
                <span class="field-error">
                  <i class="fa-solid fa-exclamation-circle"></i>
                  {{ field.error }}
                </span>
              }
              <!-- Sample value hint -->
              @if (field.info.SampleValue && !field.error) {
                <span class="field-sample">
                  Example: {{ field.info.SampleValue }}
                </span>
              }
            </div>
          }
        </div>
      }
    </div>
    <!-- Footer -->
    @if (Fields.length > 0) {
      <div class="panel-footer">
        <button class="btn btn-secondary" (click)="Reset()" title="Reset to defaults">
          <i class="fa-solid fa-undo"></i>
          Reset
        </button>
        <div class="footer-right">
          <button class="btn btn-secondary" (click)="Cancel()">
            Cancel
          </button>
          <button class="btn btn-primary"
            [disabled]="!CanSubmit"
            (click)="Submit()">
            <i class="fa-solid fa-play"></i>
            Run Query
          </button>
        </div>
      </div>
    }
  </div>
}
